/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".theme-1[_ngcontent-%COMP%]   .guests-popover[_ngcontent-%COMP%]{width:100%!important}.custom-radio[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .custom-radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
